import INDICADORES from './INDICADORES';

const BENCHMARKS = {
  DI: { ...INDICADORES.DI, index: 0 },
  SELIC: { ...INDICADORES.SELIC, index: 1 },
  IBOV: { ...INDICADORES.IBOV, index: 2 },
  IDIV: { ...INDICADORES.IDIV, index: 3 },
  IFIX: { ...INDICADORES.IFIX, index: 4 },
  IMAB: { ...INDICADORES.IMAB, index: 5 },
  USD: { ...INDICADORES.USD, index: 6 }
};

export default BENCHMARKS;
